<template>
    <slot></slot>
</template>

<script setup>
import {onErrorCaptured} from "vue";

onErrorCaptured((err, vm, info) => {
    return false;
});
</script>

<style scoped>

</style>